'use client';

import { useEffect } from 'react';

/**
 * Register the FlowStage service worker on first paint of an
 * authenticated route. The worker is push-notification-only — no
 * caching layer — so registering it has no effect on existing fetch
 * behavior. Skipped entirely in dev to avoid the classic "service
 * worker is serving stale JS" loop during hot reload.
 */
export default function RegisterServiceWorker() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!('serviceWorker' in navigator)) return;
    // Don't register in dev — Next.js hot reload + SW caching = pain.
    if (process.env.NODE_ENV !== 'production') return;

    const register = async () => {
      try {
        await navigator.serviceWorker.register('/sw.js', { scope: '/' });
      } catch (err) {
        console.warn('[sw] registration failed', err);
      }
    };
    void register();
  }, []);

  return null;
}
